// @flow

import _ from 'lodash';

import { getNextParam, getQueryParam } from 'app/common/utils/RouterSelectors';

const LINK_TO_EDITOR_RE = /app\/(editor|instant)/;
const LINK_TO_APPS_CREATE_RE = /apps\/create/;
const LINK_TO_USE_CASE_RE = /app\/use-case\//;
const LINK_TO_SHARED_ZAP_RE = /app\/shared\//;
const LINK_TO_JOIN_TEAM_RE = /teams\/join\//;

const HIGH_INTENT_NEXT_LINKS = [
  LINK_TO_EDITOR_RE,
  LINK_TO_APPS_CREATE_RE,
  LINK_TO_USE_CASE_RE,
  LINK_TO_SHARED_ZAP_RE,
  LINK_TO_JOIN_TEAM_RE,
];

type State = {
  router: {
    current: { query: { next?: string } },
    next: ?{ query?: { next: string } },
  },
};

const isNextValid = next => {
  const hasNext = !_.isEmpty(next);
  return hasNext && HIGH_INTENT_NEXT_LINKS.some(re => re.test(next));
};

export const isHighIntent = (state: State): boolean => {
  const next = getQueryParam(state, 'next') || getNextParam(state, 'next');
  const hasHightIntentNext = isNextValid(next);

  const selectedApis =
    getQueryParam(state, 'selected_apis') ||
    getNextParam(state, 'selected_apis');
  const hasSelectedApis = !_.isEmpty(selectedApis);

  return hasHightIntentNext || hasSelectedApis;
};
